import React from 'react';
import { Field } from '../../types';

export interface FormParagraphProps {
  field: Field;
}
function FormParagraph(props: FormParagraphProps) {
  const { field } = props;
  return (
    <div className="form-para">
      <p>{field.text}</p>
    </div>
  );
}
export default FormParagraph;
